import {
  CabinCategoryCfmModel,
  IGetShipsResponse,
  PlanMyCruiseContainerWrapperProps,
} from '@msc-b2c/interfaces/types';
import { useDispatch, useSelector } from 'react-redux';
import {
  AppDispatch,
  cardSortingList,
  categoryOrderUpdate,
  confirmationDrawerProps,
  countDaysUntil,
  diningHeadsUpMessagesProps,
  diningProps,
  drawerExcursionProps,
  drawerProps,
  excursionsEmptyNoteRetrieved,
  fetchAllInclusivePrepaidsFromFragment,
  fetchContentFragmentsFromCms,
  getActiveSession,
  GetExcursionsMyMSC,
  mscGet,
  mscRemove,
  setErrorManagerCode,
  GetItineraryMyMSC,
  GetOnboardServicesByCruiseIdMyMSC,
  headsUpMessagesProps,
  membershipsData,
  mergeItinerariesByCruiseId,
  myAreaAllInclusiveCmsItems,
  myAreaCabinDetails,
  myAreaCheckIn,
  myAreaExcursions,
  myAreaItinerary,
  myAreaOBS,
  obsEmptyNoteRetrieved,
  optExcursionBannerRetrive,
  prePaidCardProps,
  RootState,
  setIsErrorModalOpen,
  setShipCF,
  triggerShowEmptyNote,
  triggerShowNoResult,
  useGetBookingQuery,
  useLazyGetCheckinsQuery,
} from '@msc-b2c/shared-utils';
import PlanMyCruiseContainer from './PlanMyCruiseContainer';
import {
  ErrorManagerCodeEnum,
  LoginMode,
  LoginStatusAnalyticsEnum,
} from '@msc-b2c/interfaces/enums';
import { useCallback, useEffect, useRef, useState } from 'react';
import {
  findCabinCategory,
  getBookedExperienceDetail,
  getCabinIdOfTheLoggedUser,
  getCabinObjectOfTheLoggedUser,
  getDepartureDate,
  getExperienceTitleFallback,
  getMembershipData,
  isXDaysBeforeDeparture,
} from '../utils/myAreaUtils';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRouteToNavigate } from '../navigationmenu/utils/navigationMenuUtils';
import { skipToken } from '@reduxjs/toolkit/query/react';
import { triggerBookingStatusEvent } from '../utils/myAreaAnalytics';
import {
  CheckInsMyMSCResponse,
  IFetchShipsFromFragmentsURLParams,
  IGetExperienceDetailsResponse,
} from '@msc-b2c/interfaces/interfaces';
import { getCheckInStatus } from '../webcheckin/helpers/helpers';
import { mapCabinCategories } from '../utils/utils';

let hasTriggeredBookingStatusForSession = false;

export function PlanMyCruiseContainerWrapper({
  perChildLabel,
  perCabinLabel,
  perPackageLabel,
  perAdultLabel,
  chefLabel,
  foodTypeLabel,
  durationLabel,
  durationValueLabel,
  codeLabel,
  alreadyBookedLabel,
  dayLabel,
  dayAtSeaLabelValue,
  explorerPackageLabel,
  closeDrawerLabel,
  closeDrawerIcon,
  drawerEditLabel,
  updatingStatusLabel,
  updatingStatusLabelIcon,
  updatingConfirmationLabel,
  limitedSeatsPlaceholder,
  myPlanButtonLabel,
  myPlanButtonDiningLabel,
  passengersLabel,
  addonEligiblePassengersLabel,
  allPassengersLabel,
  allEligiblePassengersLabel,
  overviewLabel,
  difficultyLevelLabel,
  tourLanguageLabel,
  stateroomLabel,
  minimumParticipantsLabel,
  bannerColorPicker,
  fontColorPicker,
  otherLabel,
  alreadyInCartMessageLabel,
  alreadyInCartCtaLabel,
  alreadyInCartCtaLink,
  zeroResultsExcursion,
  zeroResultsObs,
  optBannerExcursion,
  headsUpMessages,
  diningHeadsUpMessages,
  myPlanAlreadyPurchasedButtonLabel,
  myPlanButtonPurchaseDisabledLabel,
  disableEmbarkAndDisembarkExcursions,
  drawerExcursionType,
  confirmationDrawer,
  cardPillConfigurations,
  drawerPillConfigurations,
  limitedSeatsPlaceholderThreshold,
  disableAdditionalNotesTooltip,
  tooltipLabel,
  tooltipIcon,
  children,
  carModelLabelPlaceholder,
  carPlateLabelPlaceholder,
  validationRulesCarModelPlateContainer,
  categoryOrder,
  promotionPriceEnabled,
  showSinglePromotionPrice,
  sortingList,
  visibilityRulesConfiguration,
  allInclusiveInCartErrorTitle,
  allInclusiveInCartErrorDescription,
  allInclusiveInCartErrorButtonText,
  refundEligiblePassengersLabel,
  refundAddPassengersButtonLabel,
  refundRequestButtonLabel,
  refundCancelButtonLabel,
  refundConfirmButtonLabel,
  refundConfirmationIcon,
  refundProcessingIcon,
  refundProcessingLabel,
  refundConfirmationTitle,
  refundConfirmationDescriptionExcursions,
  refundConfirmationDescriptionOBS,
  refundConfirmationDescriptionSubtitleExcursions,
  refundConfirmationDescriptionSubtitleOBS,
  refundSuccessIcon,
  refundSuccessTitle,
  refundSuccessDescription,
  refundSuccessCloseButtonLabel,
  refundErrorIcon,
  refundErrorTitle,
  refundErrorDescription,
  refundErrorButtonCta,
  diningRequestRefundCtaLabel,
  //DINING PROPS PAX STEP
  diningPax,
  //DINING PROPS CHOOSE_WHEN_BOOK
  diningChooseWhenBook,
  //DINING PROPS DATE_TIME_STEP
  diningDateTime,
  diningCloseModal,
  diningReservationRecap,
  diningCartRecap,
  diningCTA,
}: Readonly<PlanMyCruiseContainerWrapperProps>) {
  const PREPAIDCARDCONTAINER_XF_QUERY =
    '.cmp-prepaidcardcontainer .cardWrapper .experience-fragment';
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { allMyCruisesLink, navigationItems } = useSelector(
    (state: RootState) => state.navigationMenuData
  );

  const { activeBookingNumber, activeCruiseId, cabinDetails, itinerary, membershipData } =
    useSelector((state: RootState) => state.myCruise);
  const itinerariesByCruiseId = useSelector(
    (state: RootState) => state.myAreaCommonConfig.itinerariesByCruiseId
  );
  const [checkInStatus, setCheckInStatus] = useState<CheckInsMyMSCResponse | null>(null);
  const [fetchCheckins] = useLazyGetCheckinsQuery();
  const { is3dsFlow } = useSelector((state: RootState) => state.payment);
  const isTargetVec = window !== window.top;
  const bookingStatusTriggeredRef = useRef(false);
  const shipDataFetchedForBookingRef = useRef<string | null>(null);
  const shipDataFetchInProgressForBookingRef = useRef<string | null>(null);

  categoryOrder && dispatch(categoryOrderUpdate(categoryOrder));

  dispatch(
    prePaidCardProps({
      myPlanAlreadyPurchasedButtonLabel,
      myPlanButtonPurchaseDisabledLabel,
      perChildLabel,
      perCabinLabel,
      perPackageLabel,
      perAdultLabel,
      chefLabel,
      foodTypeLabel,
      durationLabel,
      durationValueLabel,
      codeLabel,
      alreadyBookedLabel,
      dayLabel,
      dayAtSeaLabelValue,
      explorerPackageLabel,
      myPlanButtonLabel,
      myPlanButtonDiningLabel,
      disableEmbarkAndDisembarkExcursions,
      cardPillConfigurations,
      promotionPriceEnabled,
      showSinglePromotionPrice,
      allInclusiveInCartErrorTitle,
      allInclusiveInCartErrorDescription,
      allInclusiveInCartErrorButtonText,
      refundEligiblePassengersLabel,
      refundAddPassengersButtonLabel,
      refundRequestButtonLabel,
      refundCancelButtonLabel,
      refundConfirmButtonLabel,
      refundConfirmationIcon,
      refundProcessingIcon,
      refundProcessingLabel,
      refundConfirmationTitle,
      refundConfirmationDescriptionExcursions,
      refundConfirmationDescriptionOBS,
      refundConfirmationDescriptionSubtitleExcursions,
      refundConfirmationDescriptionSubtitleOBS,
      refundSuccessIcon,
      refundSuccessTitle,
      refundSuccessDescription,
      refundSuccessCloseButtonLabel,
      refundErrorIcon,
      refundErrorTitle,
      refundErrorDescription,
      refundErrorButtonCta,
      diningRequestRefundCtaLabel,
    })
  );

  dispatch(
    drawerProps({
      limitedSeatsPlaceholder,
      closeDrawerLabel,
      closeDrawerIcon,
      drawerEditLabel,
      updatingStatusLabel,
      updatingStatusLabelIcon,
      updatingConfirmationLabel,
      passengersLabel,
      addonEligiblePassengersLabel,
      allPassengersLabel,
      allEligiblePassengersLabel,
      overviewLabel,
      difficultyLevelLabel,
      tourLanguageLabel,
      stateroomLabel,
      minimumParticipantsLabel,
      bannerColorPicker,
      fontColorPicker,
      otherLabel,
      alreadyInCartMessageLabel,
      alreadyInCartCtaLabel,
      alreadyInCartCtaLink,
      drawerPillConfigurations,
      limitedSeatsPlaceholderThreshold,
      disableAdditionalNotesTooltip,
      tooltipLabel,
      tooltipIcon,
      carModelLabelPlaceholder,
      carPlateLabelPlaceholder,
      validationRulesCarModelPlateContainer,
    })
  );
  dispatch(
    drawerExcursionProps({
      drawerExcursionType,
    })
  );
  dispatch(confirmationDrawerProps(confirmationDrawer));
  dispatch(headsUpMessagesProps(headsUpMessages));
  dispatch(diningHeadsUpMessagesProps(diningHeadsUpMessages));
  dispatch(cardSortingList(sortingList));
  //DINING PROPS
  dispatch(
    diningProps({
      diningPaxProps: diningPax,
      diningChooseWhenBookProps: diningChooseWhenBook,
      diningDateTimeProps: diningDateTime,
      diningCloseModalProps: diningCloseModal,
      diningReservationRecapProps: diningReservationRecap,
      diningCartReservationRecapProps: diningCartRecap,
      diningCTA: diningCTA,
    })
  );

  const location = useLocation();

  zeroResultsExcursion && dispatch(excursionsEmptyNoteRetrieved(zeroResultsExcursion));
  zeroResultsObs && dispatch(obsEmptyNoteRetrieved(zeroResultsObs));
  optBannerExcursion && dispatch(optExcursionBannerRetrive(optBannerExcursion));

  const {
    loginMode,
    bookingNumber: sessionBookingNumber = '',
    cruiseId: sessionCruiseId = '',
    allCruisesID,
    goldenId,
  } = getActiveSession();
  const bookingNumber = activeBookingNumber || sessionBookingNumber;
  const cruiseId = activeCruiseId || sessionCruiseId;

  const isLightLogin = loginMode === LoginMode.LIGHT;
  const shipInfo = useSelector((state: RootState) => state.bookingContentFragment.ship);
  const [experiences, setExperiences] = useState<IGetExperienceDetailsResponse>();
  const [itemsToHide, setItemsToHide] = useState<string[]>(null);
  const [readyToFetchApis, setReadyToFetchApis] = useState(false);

  useEffect(() => {
    const innerTeaserLightLogin = document.querySelectorAll('.teaser.cmp-teaser__icon-teaser-cta');

    const innerTeaserFullLogin = document.querySelectorAll(
      '.teaser.teaser.cmp-teaser__simple-card'
    );

    innerTeaserLightLogin?.forEach((teaser) => {
      teaser.classList.add(isLightLogin ? 'isLightLogin' : 'isFullLogin');
    });

    innerTeaserFullLogin?.forEach((teaser) => {
      teaser.classList.add(isLightLogin ? 'isLightLogin' : 'isFullLogin');
    });
  }, [loginMode, location]);

  // GET BOOKING API CALL
  const { data: booking, isLoading } = useGetBookingQuery(
    bookingNumber !== '' ? bookingNumber : skipToken
  );

  const fetchShipDataFromFragments = useCallback(() => {
    const shipCode = booking?.cabins?.[0]?.cruise?.ship?.code.slice(0, 2) ?? '';
    if (!shipCode) return;

    fetchContentFragmentsFromCms<IGetShipsResponse, IFetchShipsFromFragmentsURLParams>('getShips', {
      shipCode,
    })
      .then((result) => {
        const shipList = result?.data?.shipCfmList?.items;
        const selectedShip = shipList?.[0];

        if (selectedShip) {
          dispatch(setShipCF(selectedShip));
        } else {
          dispatch(setIsErrorModalOpen(true));
        }

        const cabinOfTheLoggedUser = getCabinObjectOfTheLoggedUser(booking);
        const categoryCode = cabinOfTheLoggedUser?.categoryCode;
        const cabinCategoryInterior =
          result?.data?.shipCfmList?.items?.[0]?.interiorCategoryCf?.find(
            (item) => item.cabinCode === categoryCode
          );
        const cabinCategoryOceanView =
          result?.data?.shipCfmList?.items?.[0]?.oceanViewCategoryCf?.find(
            (item) => item.cabinCode === categoryCode
          );
        const cabinCategoryBalcony = result?.data?.shipCfmList?.items?.[0]?.balconyCategoryCf?.find(
          (item) => item.cabinCode === categoryCode
        );
        const cabinCategorySuite = result?.data?.shipCfmList?.items?.[0]?.suiteCategoryCf?.find(
          (item) => item.cabinCode === categoryCode
        );
        const cabinCategoryYachtClub =
          result?.data?.shipCfmList?.items?.[0]?.yachtClubCategoryCf?.find(
            (item) => item.cabinCode === categoryCode
          );

        const cabinCategory: CabinCategoryCfmModel | undefined =
          cabinCategoryInterior ??
          cabinCategoryOceanView ??
          cabinCategoryBalcony ??
          cabinCategorySuite ??
          cabinCategoryYachtClub ??
          undefined;

        // set the cabinCategory
        dispatch(myAreaCabinDetails(cabinCategory));
      })
      .catch((error) => {
        console.error('Error fetching ship content fragment:', error);
        dispatch(setIsErrorModalOpen(true));
      })
      .finally(() => {
        shipDataFetchInProgressForBookingRef.current = null;
      });

    fetchContentFragmentsFromCms<IGetExperienceDetailsResponse, undefined>('getExperienceDetails')
      .then((result) => {
        setExperiences(result);
      })
      .catch((error) => {
        console.error('Error fetching experience details:', error);
      });
  }, [booking]);

  useEffect(() => {
    if (booking) {
      const experienceCf = getBookedExperienceDetail(booking, experiences);

      /* PREPAID VISIBILITY RESTRICTION - RULES LOGIC - START */
      // filter results based on the visibility restrictions
      const cabinCategoriesMapped = mapCabinCategories(shipInfo);
      const experienceOfTheLoggedUser = experienceCf?.experienceItemCodeList;
      const cabinOfTheLoggedUser = getCabinObjectOfTheLoggedUser(booking)?.categoryCode;
      const macroCategoryOfLoggedUser = findCabinCategory(
        cabinOfTheLoggedUser,
        cabinCategoriesMapped
      );

      // if there's a match between experienceOfTheLoggedUser and the experienceCode in the visibilityRulesConfiguration we have to collect the configured itemCodesToHide
      const itemsToHide = visibilityRulesConfiguration?.reduce((rulesAccumulator, rule) => {
        if (
          (((experienceOfTheLoggedUser?.includes(rule.experienceVisibilityRestriction) &&
            rule.cabinMacroCategoryVisibilityRestriction === macroCategoryOfLoggedUser) ||
            (experienceOfTheLoggedUser?.includes(rule.experienceVisibilityRestriction) &&
              !rule.cabinMacroCategoryVisibilityRestriction) ||
            (rule.cabinMacroCategoryVisibilityRestriction === macroCategoryOfLoggedUser &&
              !rule.experienceVisibilityRestriction)) &&
            rule.itemCodesToHide) ||
          (rule.itemCodesToHide &&
            !rule.experienceVisibilityRestriction &&
            !rule.cabinMacroCategoryVisibilityRestriction)
        ) {
          rulesAccumulator.push(...rule.itemCodesToHide);
        }
        return rulesAccumulator;
      }, []);
      setItemsToHide(itemsToHide);
      /* PREPAID VISIBILITY RESTRICTION - RULES LOGIC - END */
    }
    if (booking && experiences && shipInfo && itemsToHide !== null) {
      setReadyToFetchApis(true);
    }
  }, [booking, cruiseId, shipInfo, experiences]);

  useEffect(() => {
    if (booking) {
      const experienceCf = getBookedExperienceDetail(booking, experiences);
      const cabinExperienceFallback = getExperienceTitleFallback(booking);
      const cabinExperienceLabels = experiences?.data
        ? experienceCf?.experienceTitle || cabinExperienceFallback
        : null;
      const cruiseId = booking.cabins?.[0]?.cruise?.id;
      const shouldFetchShipData =
        cruiseId &&
        shipDataFetchInProgressForBookingRef.current !== bookingNumber &&
        (!cabinDetails || shipDataFetchedForBookingRef.current !== bookingNumber);

      if (shouldFetchShipData) {
        shipDataFetchInProgressForBookingRef.current = bookingNumber;
        shipDataFetchedForBookingRef.current = bookingNumber;
        fetchShipDataFromFragments();
      }

      if (
        shipInfo &&
        cruiseId &&
        cabinExperienceLabels &&
        (isLightLogin || membershipData) &&
        checkInStatus
      ) {
        const departureDate = getDepartureDate(booking);
        const days = countDaysUntil(new Date().toISOString(), departureDate);

        const checkinStatus = getCheckInStatus(days, checkInStatus);

        if (!bookingStatusTriggeredRef.current && !hasTriggeredBookingStatusForSession) {
          triggerBookingStatusEvent(
            booking,

            isLightLogin
              ? LoginStatusAnalyticsEnum.LIGHT_LOGIN
              : LoginStatusAnalyticsEnum.FULL_LOGIN,
            cabinExperienceLabels,
            checkinStatus,
            bookingNumber,
            membershipData?.memberships[0]?.points?.current,
            isLightLogin ? undefined : allCruisesID,
            goldenId
          );
          bookingStatusTriggeredRef.current = true;
          hasTriggeredBookingStatusForSession = true;
        }
      }
    }
  }, [booking, shipInfo, membershipData, experiences, checkInStatus, cabinDetails]);

  // GET ITINERARY AND EXCURSIONS
  useEffect(() => {
    if (is3dsFlow || isTargetVec) return;
    if (!bookingNumber) {
      /* Scenario when user has no bookings.
       * The Plan My Cruise container should not be rendered and user redirected to All My Cruises page
       */
      const route = getRouteToNavigate(navigationItems || [], allMyCruisesLink?.url ?? '');
      navigate(`${route}${window.location.href.includes('.html') ? '.html' : ''}`);
    } else if (
      !isLoading &&
      readyToFetchApis &&
      booking &&
      cruiseId &&
      itemsToHide !== null &&
      itinerary === null
    ) {
      // ITINERARY: reuse the cached entry written by AllMyCruises (if the
      // user navigated here from there post token-upgrade) instead of firing
      // /cruises/{cruiseId}/itinerary again for data we already have.
      const cachedItinerary = itinerariesByCruiseId?.[cruiseId];
      if (cachedItinerary) {
        // Deep-clone before dispatching: the cached value lives in Redux state
        // and is therefore frozen by RTK's autoFreeze. The `myAreaItinerary`
        // reducer mutates the payload (it sets `selectedDayFilter` on it),
        // which would throw "object is not extensible" against the frozen
        // source. A JSON round-trip matches the network path, which always
        // hands the reducer a fresh, mutable plain-JSON object.
        dispatch(myAreaItinerary(JSON.parse(JSON.stringify(cachedItinerary))));
      } else {
        const getItineraryCardData = new GetItineraryMyMSC(false, {
          cruiseId: cruiseId,
        });

        getItineraryCardData.getData().then((res) => {
          dispatch(myAreaItinerary(res));
          // Seed the cache for any future Overview transitions that target
          // the same cruiseId (e.g. multi-cruise selection within a booking).
          dispatch(mergeItinerariesByCruiseId({ [cruiseId]: res }));
        });
      }

      if (loginMode === LoginMode.FULL && !membershipData) {
        getMembershipData().then((res) => {
          dispatch(membershipsData(res?.memberships ? res : { memberships: [] }));
        });
      }

      // EXCURSIONS API CALL
      const getMyMSCExcursionsData = new GetExcursionsMyMSC(false, {
        cruiseId: cruiseId,
        bookingNumber: bookingNumber,
        includeDepartureAndArrivalPorts: !disableEmbarkAndDisembarkExcursions,
      });

      if (isXDaysBeforeDeparture(getDepartureDate(booking))) {
        dispatch(triggerShowEmptyNote(true));
      }

      getMyMSCExcursionsData
        .getData()
        .then((res) => {
          // filter results based on the visibility restrictions
          res.excursions = res.excursions.filter(
            (excursion) => excursion?.code && !itemsToHide?.includes(excursion.code)
          );
          dispatch(myAreaExcursions(res));
          if (!res.excursions || res?.excursions?.length === 0) {
            dispatch(triggerShowNoResult(true));
          }
        })
        .catch(() => {
          dispatch(myAreaExcursions({ excursions: [] }));
          dispatch(triggerShowNoResult(true));
        });

      // OBS API CALL
      const getMyMSCOBSData = new GetOnboardServicesByCruiseIdMyMSC(false, {
        cruiseID: cruiseId,
        bookingNumber: bookingNumber,
      });

      fetchAllInclusivePrepaidsFromFragment()
        .then((cmsItems) => {
          dispatch(myAreaAllInclusiveCmsItems(cmsItems));
        })
        .catch(() => {
          dispatch(myAreaAllInclusiveCmsItems([]));
        });

      getMyMSCOBSData
        .getData()
        .then((res) => {
          const onboardServices = res.onboardServices ?? [];

          // filter results based on the visibility restrictions
          res.onboardServices = onboardServices.filter(
            (obs) => obs?.code && !itemsToHide?.includes(obs.code)
          );

          if (!res.onboardServices || res?.onboardServices?.length === 0) {
            dispatch(triggerShowNoResult(true));
          }

          // dispatch results in store
          dispatch(myAreaOBS(res));
        })
        .catch(() => {
          dispatch(myAreaOBS({ onboardServices: [] }));
          dispatch(triggerShowNoResult(true));
        });

      const cabinId: string = getCabinIdOfTheLoggedUser(booking) ?? '';
      fetchCheckins({ bookingNumber, cabinId }).then((res) => {
        if (res.data) {
          setCheckInStatus(res.data);
          dispatch(myAreaCheckIn(res.data));
        }
      });
    }
  }, [readyToFetchApis, itinerary, is3dsFlow]);

  useEffect(() => {
    setReadyToFetchApis(false);
    setCheckInStatus(null);
  }, [bookingNumber]);

  useEffect(() => {
    if (booking && experiences && shipInfo && itemsToHide !== null) {
      setReadyToFetchApis(true);
    }
  }, [booking, shipInfo]);

  // Hide experience fragments if necessary
  useEffect(() => {
    const experienceFragments = document.querySelectorAll(PREPAIDCARDCONTAINER_XF_QUERY);

    experienceFragments.forEach((fragment) => {
      if (booking && isXDaysBeforeDeparture(getDepartureDate(booking))) {
        fragment.classList.add('hidden');
      } else {
        fragment.classList.remove('hidden');
      }
    });
  }, [booking]);

  /* API CALLS END */
  return booking && cruiseId && <PlanMyCruiseContainer>{children}</PlanMyCruiseContainer>;
}

export default PlanMyCruiseContainerWrapper;

PlanMyCruiseContainerWrapper.aemResourceType =
  'b2c-website-foundation/components/mymsc/planmycruisecontainer';
